export default __webpack_public_path__ + "static/media/profile.2e05dd5f.svg";